<template>
	<div id="cf-turnstile"></div>
</template>

<script setup>
	import { onMounted, onUnmounted } from "vue"

	const emits = defineEmits(["token"])

	const props = defineProps({
		siteKey: String,
	})

	function loadScript() {
		const url = `https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit`
		const script = document.createElement("script")
		script.src = url
		script.async = true
		script.defer = true
		script.addEventListener("error", () => {
			console.error("Failed to load Cloudflare Turnstile script")
		})
		script.onload = () => {
			// console.log("SiteKey", props.siteKey)
			window.turnstile.render("#cf-turnstile", {
				sitekey: props.siteKey,
				callback(token) {
					// console.log("Turnstile challenge succeeded", token)
					emits("token", token)
				},
				"error-callback"(error) {
					console.error("Turnstile challenge failed", error)
				},
			})
		}
		document.head.appendChild(script)
	}

	onMounted(() => {
		loadScript()
	})

	onUnmounted(() => {
		delete window.turnstile
	})
</script>
